varying highp vec2 v_texturecoord;

uniform vec2 u_resolution;
uniform float u_time;
uniform float u_damage;
uniform sampler2D u_sampler;
uniform sampler2D u_gradient;
uniform sampler2D u_stars;
uniform vec2 u_boss_position;
uniform float u_music_intensity;


float rand(vec2 n) { 
	return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439,
           -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy) );
  vec2 x0 = v -   i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod(i, 289.0);
  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
  + i.x + vec3(0.0, i1.x, 1.0 ));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
    dot(x12.zw,x12.zw)), 0.0);
  m = m*m ;
  m = m*m ;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

float czm_luminance(vec3 rgb)
{
    // Algorithm from Chapter 10 of Graphics Shaders.
    const vec3 W = vec3(0.2125, 0.7154, 0.0721);
    return dot(rgb, W);
}

vec4 fluid(vec2 uv){
  //vec4 color = vec4(fract(uv.y * 10.),0,0,1.0);
  float n = (snoise(uv * vec2(0.7,1.5)  + vec2(u_time, .0) * .1) + snoise(uv * vec2(0.5,3.) + vec2(u_time, .0) * .05)) * 2.;
  float up = smoothstep(0.,0.1,n);
  float down = smoothstep(0.6,0.4,n);
  vec4 color = texture2D(u_gradient,uv + n) * up * down;
  float l = czm_luminance(color.rgb) * 0.5;
  vec3 d = mix(vec3(l),color.rgb, 0.);
  return vec4(d,1.0);
}

void main(void) {
  vec2 pixel = (gl_FragCoord.xy / u_resolution.x);
  vec2 ratio = vec2(1. ,u_resolution.y / u_resolution.x);
  vec2 uv = v_texturecoord;

  vec4 color = texture2D(u_sampler, uv);

  float dist = distance((uv - vec2(0.5)) * ratio + vec2(0.5), (u_boss_position - vec2(0.5)) * ratio + vec2(0.5));
  float ripple = fract(dist * 5. - u_time * 60./117. * 4.);
  float r = 0.8;
  float s = 0.1;
  float w = 0.1;
  ripple = smoothstep(r + w, r + w + s,ripple) + (1.-smoothstep(r, r + s,ripple));
  float rs = .05 * smoothstep(0.6, 0.,dist) * u_music_intensity;
  ripple = ripple * rs + (1. - rs); 
  uv *= ripple;

  vec4 cloud = fluid(uv);

  vec4 stars1 = texture2D(u_stars, fract(uv * ratio * 3. + vec2(u_time * 0.1,0)));
  vec4 stars2 = texture2D(u_stars, fract(uv * ratio  * 5. + vec2(u_time * 0.1,0))) * 0.5;

  vec4 stars = (stars1 + stars2) * 0.6;
  vec4 bg = mix(stars, cloud, clamp(cloud * 3.,0.,1.));



  vec4 final = mix(bg, color, color.a);
  gl_FragColor = final;
}
